/* eslint-disable */
import { KROT } from 'captcha-eu-sdk'

let krotInstance = null
let initPromise = null
let solvePromise = null

async function initKrot() {
  if (krotInstance) {
    return krotInstance
  }

  if (!initPromise) {
    initPromise = (async () => {
      KROT.KROT_HOST = 'https://www.captcha.eu'

      const initResult = KROT.init()
      if (initResult && typeof initResult.then === 'function') {
        await initResult
      }

      const publicKey = process.env.VUE_APP_CAPTCHA_EU_PUBLIC_KEY
      if (publicKey && typeof KROT.setup === 'function') {
        KROT.setup(publicKey)
      } else if (!publicKey) {
        console.warn('Captcha.eu public key missing (VUE_APP_CAPTCHA_EU_PUBLIC_KEY)')
      }

      krotInstance = KROT
      return krotInstance
    })().catch((error) => {
      console.error('Captcha.eu init error:', error)
      initPromise = null
      return null
    })
  }

  return await initPromise
}

function initCaptcha() {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initKrot)
  } else {
    initKrot()
  }
}

async function getCaptchaSolution() {
  if (solvePromise) {
    return await solvePromise
  }

  solvePromise = (async () => {
    const krot = await initKrot()
    if (!krot || typeof krot.getSolution !== 'function') {
      return null
    }

    try {
      return await krot.getSolution()
    } catch (error) {
      console.error('Captcha.eu getSolution error:', error)
      return null
    } finally {
      solvePromise = null
    }
  })()

  return await solvePromise
}

async function resetCaptcha() {
  const krot = await initKrot()
  if (krot && typeof krot.reset === 'function') {
    krot.reset()
  }
}

export { initCaptcha, getCaptchaSolution, resetCaptcha }
